import { render, staticRenderFns } from "./peers-listing.component.vue?vue&type=template&id=6f8c18db&"
import script from "./peers-listing.component.ts?vue&type=script&lang=ts&"
export * from "./peers-listing.component.ts?vue&type=script&lang=ts&"
import style0 from "./peers-listing.component.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports